import styled from 'styled-components';
import colors from 'Styles/colors';

export const OptionRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 10px;
`;
OptionRow.displayName = 'OptionRow';

export const OptionInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`;
OptionInfo.displayName = 'OptionInfo';

export const OptionName = styled.div`
  font-size: 13.5px;
  font-weight: 600;
  color: ${({ theme }) => theme.selector.text};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
OptionName.displayName = 'OptionName';

export const OptionEmail = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: ${colors.dark6};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
OptionEmail.displayName = 'OptionEmail';

export const RolePill = styled.span`
  flex-shrink: 0;
  font-size: 11.5px;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: 12px;
  background-color: ${colors.white9};
  color: ${colors.dark4};
  white-space: nowrap;
  text-transform: capitalize;
`;
RolePill.displayName = 'RolePill';
